import LinesEllipsis from 'react-lines-ellipsis';
import React from 'react';
import responsiveHOC from 'react-lines-ellipsis/lib/responsiveHOC';
import ChopLines from './choplines/chop-lines';

interface OnTruncateParameters {
    clamped: boolean;
}

interface TruncateLinesProps {
    text?: string;
    unsafeHTML?: string;
    lines: number;
    onTruncate?: (params: OnTruncateParameters) => any;
}

const ResponsiveLinesEllipsis = responsiveHOC()(LinesEllipsis);

class ActiveEllipsis extends React.Component<{mountStateChangeCallback?: (params: OnTruncateParameters) => any}> {
    componentDidMount(): void {
        if (!!this.props.mountStateChangeCallback) {
            this.props.mountStateChangeCallback({clamped: true});
        }
    }

    componentWillUnmount(): void {
        if (!!this.props.mountStateChangeCallback) {
            this.props.mountStateChangeCallback({clamped: false});
        }
    }

    render(): JSX.Element {
        return(
        <span />
        );
    }
}

const TruncateLines: React.SFC<TruncateLinesProps> = (props: TruncateLinesProps) => {
    if (!!props.text) {
        return (
            <ResponsiveLinesEllipsis
                text={props.text}
                maxLine={props.lines * 2}
                basedOn={'letters'}
                trimRight={true}
                ellipsis={'…'} // This is &hellip;
                onReflow={props.onTruncate}
                // Newer versions of Chrome crop the text more than necessary
                // pre-wrap fixes it https://github.com/xiaody/react-lines-ellipsis/issues/59
                style={{whiteSpace: 'pre-wrap'}}
            />
        );
    }
    if (!!props.unsafeHTML) {
        return (
            <ChopLines lines={props.lines} lineHeight={18} ellipsis={<ActiveEllipsis mountStateChangeCallback={props.onTruncate} />}>
                <div dangerouslySetInnerHTML={{__html: props.unsafeHTML}} />
            </ChopLines>
        );
    }
    return null;
};

export default TruncateLines;
